import { fetchKYCInfo, verifyCRNumber } from '@/api/merchant/kyc'

const state = {
  kycInfo: {},
  isFetching: false,
  isVerifyingCr: false,
  crVerifySuccessDialogVisible: false,
  crVerifyErrorDialogVisible: false,
  error: null,
}

const getters = {}

const mutations = {
  SET_KYC_INFO(state, { data }) {
    state.kycInfo = { ...data }
  },
  SET_FETCHING(state, value) {
    state.isFetching = value
  },
  SET_VERIFYING_CR(state, value) {
    state.isVerifyingCr = value
  },
  SET_CR_VERIFY_SUCCESS_DIALOG_VISIBLE(state, value) {
    state.crVerifySuccessDialogVisible = value
  },
  SET_CR_VERIFY_ERROR_DIALOG_VISIBLE(state, value) {
    state.crVerifyErrorDialogVisible = value
  },
  SET_ERROR(state, error) {
    state.error = error
  },
}

const actions = {
  async fetchMerchantKycInfo({ commit }) {
    commit('SET_CR_VERIFY_SUCCESS_DIALOG_VISIBLE', false)
    commit('SET_CR_VERIFY_ERROR_DIALOG_VISIBLE', false)
    commit('SET_FETCHING', true)
    commit('SET_ERROR', null)
    try {
      const { data } = await fetchKYCInfo()
      commit('SET_KYC_INFO', { data: data || {} })
    } catch (error) {
      commit('SET_ERROR', error)
      commit('SET_KYC_INFO', { data: {} })
    } finally {
      commit('SET_FETCHING', false)
    }
  },

  async verifyMerchantCrNumber({ commit }) {
    commit('SET_VERIFYING_CR', true)
    commit('SET_ERROR', null)
    commit('SET_CR_VERIFY_SUCCESS_DIALOG_VISIBLE', false)
    commit('SET_CR_VERIFY_ERROR_DIALOG_VISIBLE', false)
    try {
      const { data } = await verifyCRNumber()
      commit('SET_KYC_INFO', { data: data || {} })
      commit('SET_CR_VERIFY_SUCCESS_DIALOG_VISIBLE', true)
    } catch (error) {
      commit('SET_ERROR', error)
      commit('SET_CR_VERIFY_ERROR_DIALOG_VISIBLE', true)
      const { data } = await fetchKYCInfo()
      commit('SET_KYC_INFO', { data: data || {} })
    } finally {
      commit('SET_VERIFYING_CR', false)
    }
  },

  dismissCrVerifySuccessDialog({ commit }) {
    commit('SET_CR_VERIFY_SUCCESS_DIALOG_VISIBLE', false)
  },

  dismissCrVerifyErrorDialog({ commit }) {
    commit('SET_CR_VERIFY_ERROR_DIALOG_VISIBLE', false)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
